
export const environment = {
  encryptionKey: 'somethingsomething',
    apiUrl: 'https://api-layer.s2riskwise.com/xml_api_2_9_1',
    production: true,
    buildVersion: '1.10',
    nameAppend: '',
    buildNumber: 1,
    devLoginCredentials: '2020,lee.zerafa.s2,Nugget2018!',
    isJLLBuild: '0'
};

